// UserManagement.js
import React, { useState, useEffect } from 'react';
import { Button, Table, TableBody, TableCell, TableHead, TableRow, IconButton, Dialog, DialogActions, DialogContent, DialogTitle, TextField, MenuItem } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import axios from 'axios';
import QrCodeIcon from '@mui/icons-material/QrCode';



const UserManagement = () => {
    const [empregados, setEmpregados] = useState([]);
    const [selectedEmpregado, setSelectedEmpregado] = useState(null);
    const [isModalOpen, setModalOpen] = useState(false);
    const apiBaseURL = 'https://plasticemployers.duckdns.org';      // IP da rede local

    useEffect(() => {
        // Carregar os empregados da API com autenticação
        const fetchEmpregados = async () => {
            const token = localStorage.getItem('access');
            try {
                const response = await axios.get(`${apiBaseURL}/api/empregados/`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setEmpregados(response.data);
            } catch (error) {
                console.error('Houve um erro ao carregar os empregados!', error);
            }
        };

        fetchEmpregados();
    }, []);

    const handleEdit = (empregado) => {
        setSelectedEmpregado(empregado);
        setModalOpen(true);
    };

    const handleDelete = async (id) => {
        const token = localStorage.getItem('access');
        try {
            await axios.delete(`${apiBaseURL}/api/empregados/${id}/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setEmpregados(empregados.filter(emp => emp.id !== id));
        } catch (error) {
            console.error('Houve um erro ao excluir o empregado!', error);
        }
    };

    const handleModalClose = () => {
        setSelectedEmpregado(null);
        setModalOpen(false);
    };

    const handleSave = async () => {
        const token = localStorage.getItem('access');
        try {
            if (selectedEmpregado.id) {
                const response = await axios.put(`${apiBaseURL}/api/empregados/${selectedEmpregado.id}/`, selectedEmpregado, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setEmpregados(empregados.map(emp => emp.id === response.data.id ? response.data : emp));
            } else {
                const response = await axios.post(`${apiBaseURL}/api/empregados/`, selectedEmpregado, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setEmpregados([...empregados, response.data]);
            }
            handleModalClose();
        } catch (error) {
            console.error('Houve um erro ao salvar o empregado!', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSelectedEmpregado({
            ...selectedEmpregado,
            [name]: value
        });
    };

    const handleQRGenerate = async (empregado) => {
        const token = localStorage.getItem('access');
        try {
          const response = await axios.get(`${apiBaseURL}/api/empregados/${empregado.id}/qr-generate/`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            responseType: 'blob', // Para receber o PDF como blob
          });
          // Cria uma URL a partir do blob
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          // Define o nome do arquivo com base no nome completo do empregado
          link.setAttribute('download', `${empregado.nome_completo}.pdf`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (error) {
          console.error('Erro ao gerar QR Code:', error);
        }
      };


    return (
        <div>
            <Button variant="contained" color="primary" onClick={() => setModalOpen(true)} style={{ float: 'right', marginBottom: '20px' }}>
                Criar Novo Empregado
            </Button>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Nome Completo</TableCell>
                        <TableCell>Contacto</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Turno</TableCell>
                        <TableCell>Ações</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {empregados.map(empregado => (
                        <TableRow key={empregado.id}>
                            <TableCell>{empregado.nome_completo}</TableCell>
                            <TableCell>{empregado.contacto}</TableCell>
                            <TableCell>{empregado.email}</TableCell>
                            <TableCell>{empregado.turno}</TableCell>
                            <TableCell>
                                <IconButton onClick={() => handleEdit(empregado)}>
                                    <Edit />
                                </IconButton>
                                <IconButton onClick={() => handleDelete(empregado.id)}>
                                    <Delete />
                                </IconButton>
                                <IconButton onClick={() => handleQRGenerate(empregado)}>
                                    <QrCodeIcon />
                                </IconButton>
                                </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

            {/* Modal para criação/edição de empregado */}
            <Dialog open={isModalOpen} onClose={handleModalClose}>
                <DialogTitle>{selectedEmpregado ? 'Editar Empregado' : 'Criar Novo Empregado'}</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        name="username"
                        label="Nome de Usuário"
                        fullWidth
                        value={selectedEmpregado?.username || ''}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        name="nome_completo"
                        label="Nome Completo"
                        fullWidth
                        value={selectedEmpregado?.nome_completo || ''}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        name="estado_civil"
                        label="Estado Civil"
                        select
                        fullWidth
                        value={selectedEmpregado?.estado_civil || ''}
                        onChange={handleInputChange}
                    >
                        <MenuItem value="Casado">Casado</MenuItem>
                        <MenuItem value="Solteiro">Solteiro</MenuItem>
                    </TextField>
                    <TextField
                        margin="dense"
                        name="contacto"
                        label="Contacto"
                        fullWidth
                        value={selectedEmpregado?.contacto || ''}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        name="email"
                        label="Email"
                        fullWidth
                        value={selectedEmpregado?.email || ''}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        name="data_contrato"
                        label="Data do Contrato"
                        type="date"
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={selectedEmpregado?.data_contrato || ''}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        name="data_nascimento"
                        label="Data de Nascimento"
                        type="date"
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={selectedEmpregado?.data_nascimento || ''}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        name="contacto_emergencia"
                        label="Contacto de Emergência"
                        fullWidth
                        helperText="Para uma emergência, é importante termos um número para o qual dirigir"
                        value={selectedEmpregado?.contacto_emergencia || ''}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        name="IBAN"
                        label="IBAN"
                        fullWidth
                        placeholder="Ex: PT50000201231234567890154"
                        value={selectedEmpregado?.IBAN || ''}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        name="turno"
                        label="Turno"
                        select
                        fullWidth
                        value={selectedEmpregado?.turno || ''}
                        onChange={handleInputChange}
                    >
                        <MenuItem value="manha-1">Manhã-1</MenuItem>
                        <MenuItem value="manha">Manhã</MenuItem>
                        <MenuItem value="tarde">Tarde</MenuItem>
                        <MenuItem value="noite">Noite</MenuItem>
                        <MenuItem value="normal">Normal</MenuItem>
                        <MenuItem value="horario_amamentacao">Horário de Amamentação</MenuItem>
                    </TextField>
                    <TextField
                        margin="dense"
                        name="seccao"
                        label="Seção"
                        select
                        fullWidth
                        value={selectedEmpregado?.seccao || ''}
                        onChange={handleInputChange}
                    >
                        <MenuItem value="Admin">Admin</MenuItem>
                        <MenuItem value="Escritorio">Escritório</MenuItem>
                        <MenuItem value="Design">Design</MenuItem>
                        <MenuItem value="Corte">Corte</MenuItem>
                        <MenuItem value="Impressao">Impressão</MenuItem>
                        <MenuItem value="Mini-Flexo">Mini-Flexo</MenuItem>
                        <MenuItem value="Digital">Digital</MenuItem>
                        <MenuItem value="Digital-rotativa">Digital-rotativa</MenuItem>
                        <MenuItem value="Armazem">Armazém</MenuItem>
                    </TextField>
                    <TextField
                        margin="dense"
                        name="remaining_holidays"
                        label="Saldo de Férias"
                        type="number"
                        fullWidth
                        helperText="Insira o saldo de férias (positivo ou negativo)"
                        value={selectedEmpregado?.remaining_holidays || ''}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        name="password"
                        label="Senha"
                        type="password"
                        fullWidth
                        value={selectedEmpregado?.password || ''}
                        onChange={handleInputChange}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleModalClose} color="secondary">
                        Cancelar
                    </Button>
                    <Button onClick={handleSave} color="primary">
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default UserManagement;
